// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type JobTeaserVisibleJobUserInteractionsFragment = {
  __typename?: 'VisibleJob';
  userInteractions?: {
    __typename?: 'JobUserInteractions';
    application?: {
      __typename?: 'JobUserXingApplication';
      status: Types.JobUserXingApplicationStatus;
      createdAt: string;
    } | null;
    bookmark?: {
      __typename?: 'JobBookmark';
      state: Types.JobBookmarkState;
    } | null;
  } | null;
};

export type JobTeaserVisibleJobFragment = {
  __typename?: 'VisibleJob';
  serviceOfferingGroup: number;
  activeUntil?: string | null;
  id: string;
  slug: string;
  prioritized: boolean;
  url: string;
  title: string;
  refreshedAt: string;
  globalId: string;
  redirectsToThirdPartyUrl: boolean;
  paid: boolean;
  topJob: boolean;
  userProfileMatches?: {
    __typename?: 'OntologyUserJobPostingProfileMatchResponse';
    skills?: {
      __typename?: 'JobPostingSkillMatches';
      matchedSkills?: Array<{
        __typename?: 'OntologyLocalizedJobPostingSkill';
        label: string;
      } | null> | null;
    } | null;
  } | null;
  summary?: {
    __typename?: 'JobSummaryV2';
    content?: {
      __typename?: 'JobSummaryContentV2';
      keyResponsibilities?: Array<string> | null;
    } | null;
  } | null;
  location?: { __typename?: 'JobLocation'; city?: string | null } | null;
  locations: Array<{ __typename?: 'JobLocation'; city?: string | null }>;
  employmentType?: {
    __typename?: 'EmploymentType';
    localizationValue: string;
  } | null;
  companyInfo: {
    __typename?: 'JobCompanyInfo';
    companyNameOverride: string;
    company?: {
      __typename?: 'Company';
      id: string;
      logos?: { __typename?: 'CompanyLogos'; x1?: string | null } | null;
    } | null;
  };
  salary?:
    | {
        __typename?: 'Salary';
        currency?: Types.Currency | null;
        amount?: number | null;
      }
    | {
        __typename?: 'SalaryEstimate';
        currency?: Types.Currency | null;
        minimum?: number | null;
        maximum?: number | null;
        median?: number | null;
      }
    | {
        __typename?: 'SalaryRange';
        currency?: Types.Currency | null;
        minimum?: number | null;
        maximum?: number | null;
      }
    | { __typename?: 'SalaryUnauthorized' }
    | null;
  application?:
    | { __typename: 'EasyApplication' }
    | { __typename: 'EmailApplication' }
    | { __typename: 'JobXingApplication' }
    | { __typename: 'JobXingCustomApplication' }
    | { __typename: 'MessageApplication' }
    | { __typename: 'UrlApplication'; applyUrl?: string | null }
    | null;
  userInteractions?: {
    __typename?: 'JobUserInteractions';
    application?: {
      __typename?: 'JobUserXingApplication';
      status: Types.JobUserXingApplicationStatus;
      createdAt: string;
    } | null;
    bookmark?: {
      __typename?: 'JobBookmark';
      state: Types.JobBookmarkState;
    } | null;
  } | null;
};

export type JobTeaserWithHighlightsFragment = {
  __typename?: 'VisibleJob';
  serviceOfferingGroup: number;
  activeUntil?: string | null;
  id: string;
  slug: string;
  prioritized: boolean;
  url: string;
  title: string;
  refreshedAt: string;
  globalId: string;
  redirectsToThirdPartyUrl: boolean;
  paid: boolean;
  topJob: boolean;
  matchingHighlights?: {
    __typename?: 'JobMatchingHighlightsV2';
    token: string;
    highlight?: {
      __typename?: 'JobMatchingHighlightsJobHighlightV2';
      type: string;
      localization: {
        __typename?: 'JobMatchingHighlightsLocalizableV2';
        localizationValue: string;
      };
      localizationA11y?: {
        __typename?: 'JobMatchingHighlightsLocalizableV2';
        localizationValue: string;
      } | null;
    } | null;
    matchingFacts: Array<
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactIntV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactSalaryV2';
          type: string;
          value:
            | {
                __typename?: 'Salary';
                currency?: Types.Currency | null;
                amount?: number | null;
              }
            | {
                __typename?: 'SalaryEstimate';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
                median?: number | null;
              }
            | {
                __typename?: 'SalaryRange';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
              }
            | { __typename?: 'SalaryUnauthorized' };
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactStringV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
    >;
    nonMatchingFacts: Array<
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactIntV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactSalaryV2';
          type: string;
          value:
            | {
                __typename?: 'Salary';
                currency?: Types.Currency | null;
                amount?: number | null;
              }
            | {
                __typename?: 'SalaryEstimate';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
                median?: number | null;
              }
            | {
                __typename?: 'SalaryRange';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
              }
            | { __typename?: 'SalaryUnauthorized' };
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactStringV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
    >;
  } | null;
  userProfileMatches?: {
    __typename?: 'OntologyUserJobPostingProfileMatchResponse';
    skills?: {
      __typename?: 'JobPostingSkillMatches';
      matchedSkills?: Array<{
        __typename?: 'OntologyLocalizedJobPostingSkill';
        label: string;
      } | null> | null;
    } | null;
  } | null;
  summary?: {
    __typename?: 'JobSummaryV2';
    content?: {
      __typename?: 'JobSummaryContentV2';
      keyResponsibilities?: Array<string> | null;
    } | null;
  } | null;
  location?: { __typename?: 'JobLocation'; city?: string | null } | null;
  locations: Array<{ __typename?: 'JobLocation'; city?: string | null }>;
  employmentType?: {
    __typename?: 'EmploymentType';
    localizationValue: string;
  } | null;
  companyInfo: {
    __typename?: 'JobCompanyInfo';
    companyNameOverride: string;
    company?: {
      __typename?: 'Company';
      id: string;
      logos?: { __typename?: 'CompanyLogos'; x1?: string | null } | null;
    } | null;
  };
  salary?:
    | {
        __typename?: 'Salary';
        currency?: Types.Currency | null;
        amount?: number | null;
      }
    | {
        __typename?: 'SalaryEstimate';
        currency?: Types.Currency | null;
        minimum?: number | null;
        maximum?: number | null;
        median?: number | null;
      }
    | {
        __typename?: 'SalaryRange';
        currency?: Types.Currency | null;
        minimum?: number | null;
        maximum?: number | null;
      }
    | { __typename?: 'SalaryUnauthorized' }
    | null;
  application?:
    | { __typename: 'EasyApplication' }
    | { __typename: 'EmailApplication' }
    | { __typename: 'JobXingApplication' }
    | { __typename: 'JobXingCustomApplication' }
    | { __typename: 'MessageApplication' }
    | { __typename: 'UrlApplication'; applyUrl?: string | null }
    | null;
  userInteractions?: {
    __typename?: 'JobUserInteractions';
    application?: {
      __typename?: 'JobUserXingApplication';
      status: Types.JobUserXingApplicationStatus;
      createdAt: string;
    } | null;
    bookmark?: {
      __typename?: 'JobBookmark';
      state: Types.JobBookmarkState;
    } | null;
  } | null;
};

export type JobTeaserWithHighlightsAndSummaryFragment = {
  __typename?: 'VisibleJob';
  prioritized: boolean;
  serviceOfferingGroup: number;
  activeUntil?: string | null;
  id: string;
  slug: string;
  url: string;
  title: string;
  refreshedAt: string;
  globalId: string;
  redirectsToThirdPartyUrl: boolean;
  paid: boolean;
  topJob: boolean;
  summary?: {
    __typename?: 'JobSummaryV2';
    content?: {
      __typename?: 'JobSummaryContentV2';
      keyResponsibilities?: Array<string> | null;
    } | null;
  } | null;
  matchingHighlights?: {
    __typename?: 'JobMatchingHighlightsV2';
    token: string;
    highlight?: {
      __typename?: 'JobMatchingHighlightsJobHighlightV2';
      type: string;
      localization: {
        __typename?: 'JobMatchingHighlightsLocalizableV2';
        localizationValue: string;
      };
      localizationA11y?: {
        __typename?: 'JobMatchingHighlightsLocalizableV2';
        localizationValue: string;
      } | null;
    } | null;
    matchingFacts: Array<
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactIntV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactSalaryV2';
          type: string;
          value:
            | {
                __typename?: 'Salary';
                currency?: Types.Currency | null;
                amount?: number | null;
              }
            | {
                __typename?: 'SalaryEstimate';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
                median?: number | null;
              }
            | {
                __typename?: 'SalaryRange';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
              }
            | { __typename?: 'SalaryUnauthorized' };
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactStringV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
    >;
    nonMatchingFacts: Array<
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactIntV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactSalaryV2';
          type: string;
          value:
            | {
                __typename?: 'Salary';
                currency?: Types.Currency | null;
                amount?: number | null;
              }
            | {
                __typename?: 'SalaryEstimate';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
                median?: number | null;
              }
            | {
                __typename?: 'SalaryRange';
                currency?: Types.Currency | null;
                minimum?: number | null;
                maximum?: number | null;
              }
            | { __typename?: 'SalaryUnauthorized' };
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
      | {
          __typename: 'JobMatchingHighlightsJobKeyfactStringV2';
          type: string;
          localization: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          };
          localizationA11y?: {
            __typename?: 'JobMatchingHighlightsLocalizableV2';
            localizationValue: string;
          } | null;
        }
    >;
  } | null;
  userProfileMatches?: {
    __typename?: 'OntologyUserJobPostingProfileMatchResponse';
    skills?: {
      __typename?: 'JobPostingSkillMatches';
      matchedSkills?: Array<{
        __typename?: 'OntologyLocalizedJobPostingSkill';
        label: string;
      } | null> | null;
    } | null;
  } | null;
  location?: { __typename?: 'JobLocation'; city?: string | null } | null;
  locations: Array<{ __typename?: 'JobLocation'; city?: string | null }>;
  employmentType?: {
    __typename?: 'EmploymentType';
    localizationValue: string;
  } | null;
  companyInfo: {
    __typename?: 'JobCompanyInfo';
    companyNameOverride: string;
    company?: {
      __typename?: 'Company';
      id: string;
      logos?: { __typename?: 'CompanyLogos'; x1?: string | null } | null;
    } | null;
  };
  salary?:
    | {
        __typename?: 'Salary';
        currency?: Types.Currency | null;
        amount?: number | null;
      }
    | {
        __typename?: 'SalaryEstimate';
        currency?: Types.Currency | null;
        minimum?: number | null;
        maximum?: number | null;
        median?: number | null;
      }
    | {
        __typename?: 'SalaryRange';
        currency?: Types.Currency | null;
        minimum?: number | null;
        maximum?: number | null;
      }
    | { __typename?: 'SalaryUnauthorized' }
    | null;
  application?:
    | { __typename: 'EasyApplication' }
    | { __typename: 'EmailApplication' }
    | { __typename: 'JobXingApplication' }
    | { __typename: 'JobXingCustomApplication' }
    | { __typename: 'MessageApplication' }
    | { __typename: 'UrlApplication'; applyUrl?: string | null }
    | null;
  userInteractions?: {
    __typename?: 'JobUserInteractions';
    application?: {
      __typename?: 'JobUserXingApplication';
      status: Types.JobUserXingApplicationStatus;
      createdAt: string;
    } | null;
    bookmark?: {
      __typename?: 'JobBookmark';
      state: Types.JobBookmarkState;
    } | null;
  } | null;
};

export const JobTeaserVisibleJobUserInteractionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserVisibleJobUserInteractions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteractions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'JobUserXingApplication',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookmark' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobTeaserVisibleJobUserInteractionsFragment,
  unknown
>;
export const JobTeaserVisibleJobFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserVisibleJob' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'VisibleJobCommon' },
          },
          {
            kind: 'FragmentSpread',
            name: {
              kind: 'Name',
              value: 'JobTeaserVisibleJobUserInteractions',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceOfferingGroup' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userProfileMatches' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skills' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedSkills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Salary' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Salary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalaryRange' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryRange' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalaryEstimate' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryEstimate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'median' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VisibleJobCommon' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activeUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prioritized' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'summary' },
            name: { kind: 'Name', value: 'summaryV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'keyResponsibilities' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectsToThirdPartyUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topJob' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employmentType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyNameOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logos' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'x1' },
                              name: { kind: 'Name', value: 'logo96px' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Salary' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalaryRange' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalaryEstimate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UrlApplication' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserVisibleJobUserInteractions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteractions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'JobUserXingApplication',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookmark' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobTeaserVisibleJobFragment, unknown>;
export const JobTeaserWithHighlightsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserWithHighlights' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'JobTeaserVisibleJob' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matchingHighlights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'context' },
                value: { kind: 'EnumValue', value: 'postings' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobMatchingHighlightsV2' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userProfileMatches' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skills' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedSkills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Salary' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Salary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalaryRange' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryRange' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalaryEstimate' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryEstimate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'median' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VisibleJobCommon' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activeUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prioritized' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'summary' },
            name: { kind: 'Name', value: 'summaryV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'keyResponsibilities' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectsToThirdPartyUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topJob' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employmentType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyNameOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logos' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'x1' },
                              name: { kind: 'Name', value: 'logo96px' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Salary' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalaryRange' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalaryEstimate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UrlApplication' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserVisibleJobUserInteractions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteractions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'JobUserXingApplication',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookmark' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobKeyfactV2' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobMatchingHighlightsJobKeyfactV2' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'localization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'localizationA11y' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'JobMatchingHighlightsJobKeyfactSalaryV2',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Salary' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SalaryRange' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SalaryEstimate' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserVisibleJob' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'VisibleJobCommon' },
          },
          {
            kind: 'FragmentSpread',
            name: {
              kind: 'Name',
              value: 'JobTeaserVisibleJobUserInteractions',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceOfferingGroup' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userProfileMatches' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skills' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedSkills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobMatchingHighlightsV2' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobMatchingHighlightsV2' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highlight' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localizationValue' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationA11y' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localizationValue' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matchingFacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobKeyfactV2' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nonMatchingFacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobKeyfactV2' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobTeaserWithHighlightsFragment, unknown>;
export const JobTeaserWithHighlightsAndSummaryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserWithHighlightsAndSummary' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'JobTeaserWithHighlights' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'prioritized' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'summary' },
            name: { kind: 'Name', value: 'summaryV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'keyResponsibilities' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Salary' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Salary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalaryRange' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryRange' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalaryEstimate' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryEstimate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'median' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VisibleJobCommon' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activeUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prioritized' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'summary' },
            name: { kind: 'Name', value: 'summaryV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'keyResponsibilities' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectsToThirdPartyUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topJob' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employmentType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyNameOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logos' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'x1' },
                              name: { kind: 'Name', value: 'logo96px' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Salary' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalaryRange' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalaryEstimate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UrlApplication' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserVisibleJobUserInteractions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteractions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'JobUserXingApplication',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookmark' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserVisibleJob' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'VisibleJobCommon' },
          },
          {
            kind: 'FragmentSpread',
            name: {
              kind: 'Name',
              value: 'JobTeaserVisibleJobUserInteractions',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceOfferingGroup' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userProfileMatches' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skills' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedSkills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobKeyfactV2' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobMatchingHighlightsJobKeyfactV2' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'localization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'localizationA11y' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'JobMatchingHighlightsJobKeyfactSalaryV2',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Salary' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SalaryRange' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SalaryEstimate' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobMatchingHighlightsV2' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobMatchingHighlightsV2' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highlight' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localizationValue' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationA11y' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localizationValue' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matchingFacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobKeyfactV2' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nonMatchingFacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobKeyfactV2' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTeaserWithHighlights' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VisibleJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'JobTeaserVisibleJob' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matchingHighlights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'context' },
                value: { kind: 'EnumValue', value: 'postings' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobMatchingHighlightsV2' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userProfileMatches' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skills' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedSkills' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobTeaserWithHighlightsAndSummaryFragment,
  unknown
>;
